import { RequestConfig } from '~/common/services/requests';
import { DocumentForm } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentForm = async (
  constructGet: ConstructGet,
  documentId: string,
  documentParams: DocumentParams,
  formIdentifier: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<DocumentForm> | undefined> =>
  constructGet(`${DOCUMENTS_BASE_PATH}/${documentId}/formv2`, {
    params: { form: formIdentifier, ...params },
    headers: buildHeadersFromDocumentParams(documentParams),
  });
